module.exports = __webpack_public_path__ + "static/media/checkmark_green.e7f9be5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/checkmark_green.png
// module id = 206
// module chunks = 0